import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigationStore } from "../stores";

export default function RouteTracker() {
  const { pathname } = useLocation();
  const pushRoute = useNavigationStore((s) => s.pushRoute);

  useEffect(() => {
    pushRoute({ path: pathname });
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, pushRoute]);

  return null;
}
